import { appConfigs } from "../services/config";

const { filePath } = appConfigs;

export const formatUrl = (url) => {
    let slicedUrl = url?.slice(1);
    return `${filePath}${slicedUrl}`;
}